import { SsuRunDTO } from './SsurunDTO'
import { SsuRun } from './SsurunModel'

export const mapSsuRunDtoToSsuRun = (ssuRunDTO: SsuRunDTO): SsuRun => {
    return ssuRunDTO as SsuRun
}
